export default {
  getSearchInput(state,value) {
    state.searchInput = value
    console.log(value,'value')
  }
}